import type { ValueLists } from '@ohpen/enso-ui';
import { FirmGetAllResponse, firmsSqe, type FirmsSqeRequest } from '@pmp/api';
import { useSqeList } from '@pmp/hooks';
import type { SqePage, SqeQuery } from '@pmp/utils';

import { columns, firmSqeDefaultSort, firmSqeFields } from './tableConfig';
import { OPERATION_ORDER } from './utils';

// The shape the list columns render and export: principals as the `{ key, value }` pairs a multi-value list
// reads, and operations in their display order.
const toListRow = (firm: FirmGetAllResponse): FirmGetAllResponse =>
  ({
    ...firm,
    operationsWhitelist: [...firm.operationsWhitelist].sort(
      (a, b) => OPERATION_ORDER.indexOf(a.key ?? '') - OPERATION_ORDER.indexOf(b.key ?? ''),
    ),
    principalFirm: firm.principalFirm.map(ref => ({ key: ref.id, value: ref.name ?? '' })),
  }) as unknown as FirmGetAllResponse;

const fetchFirmsPage = async (query: SqeQuery): Promise<SqePage<FirmGetAllResponse>> => {
  const { data } = await firmsSqe({ body: query as FirmsSqeRequest });
  return { items: data.items.map(toListRow), total: data.total };
};

export const useFirmsSqe = (valueLists?: ValueLists) => useSqeList(fetchFirmsPage, columns, firmSqeFields, valueLists, firmSqeDefaultSort);
